/**
 * Calculator results section with results table and charts
 */
import { lazy, Suspense } from 'react';
import { Title, Center, Loader, Stack, Divider } from '@mantine/core';
import { ResultsTable } from './TariffCalculator';
import type { OSDCode as OSDMetaCode } from '../../../utils/osdMetadata';
import type { CalculationResults, TariffType } from '../types/calculator.types';

// Lazy load ChartsVisualization for performance
const ChartsVisualization = lazy(() =>
  import('./TariffCalculator/ChartsVisualization')
    .then(m => ({ default: m.ChartsVisualization }))
);

interface CalculatorResultsSectionProps {
  results: CalculationResults;
  currentTariff: TariffType;
  baselineTariff: TariffType;
  onBaselineTariffChange: (tariff: TariffType) => void;
  selectedOSD: OSDMetaCode;
  calculationYear: number;
  resultsRef: React.RefObject<HTMLDivElement | null>;
}

export function CalculatorResultsSection({
  results,
  currentTariff,
  baselineTariff,
  onBaselineTariffChange,
  selectedOSD,
  calculationYear,
  resultsRef,
}: CalculatorResultsSectionProps) {
  return (
    <Stack gap="xl">
      <Divider my="xl" />
      
      {/* Results Table */}
      <div ref={resultsRef}>
        <Title order={2} mb="md">
          Wyniki porównania taryf
        </Title>
        <ResultsTable
          results={results}
          currentTariff={currentTariff}
          baselineTariff={baselineTariff}
          onBaselineTariffChange={onBaselineTariffChange}
          selectedOSD={selectedOSD}
          calculationYear={calculationYear}
        />
      </div>

      {/* Charts Visualization */}
      <div>
        <Title order={2} mb="md">
          Wizualizacje
        </Title>
        <Suspense fallback={<Center py="xl"><Loader size="lg" /></Center>}>
          <ChartsVisualization
            results={results}
            baselineTariff={baselineTariff}
          />
        </Suspense>
      </div>
    </Stack>
  );
}
